module.exports = __webpack_public_path__ + "static/img/bg-ClientHover-06.4e351b47.png";